import React from "react";
import Separator from "./Separator";

const BenefitsListV2 = () => {
  return (
    <>
      <Separator
        mainClass="separator separator__benefits"
        text={window.post_template.checkout_v4_benefits.tr_benefits_section_title}
      />

      {window.post_template.checkout_v4_benefits.checkout_v4_benefits_repeater &&
        window.post_template.checkout_v4_benefits.checkout_v4_benefits_repeater.map((benefit, index) => (
          <div className="benefitsV2__item" key={index}>
            <img src={benefit.tr_checkout_v4_benefits_repeater_icon} alt="" />
            <div>
              <div className="benefitsV2__item__title">{benefit.tr_checkout_v4_benefits_repeater_title}</div>
              <div className="benefitsV2__item__text">{benefit.tr_checkout_v4_benefits_repeater_text}</div>
            </div>
          </div>
        ))}
    </>
  );
};

export default BenefitsListV2;
